import * as React from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from 'hooks';
import { NO_CURRENT_ENTITY } from 'consts/store';
import { setCurrent as setCurrentCampaign } from 'store/campaigns';
import { setCurrentClient } from 'store/clients';
import { setCurrentProposal } from 'store/proposals';
//import { setCurrentProduct } from 'store/products';
import { setCurrentCommittedProposal } from 'store/proposals/committed';

type UrlParamType = {
  campaignId: number | null;
  clientId: number | null;
  proposalId: number | null;
  productId: number | null;
  committedProposalId: number | null;
};

export const UrlParamsHandler = (): null => {
  const params = useParams<{
    campaignId?: string;
    clientId?: string;
    proposalId?: string;
    productId?: string;
    committedProposalId?: string;
  }>();
  const dispatch = useAppDispatch();
  const [parsedParams, setParsedParams] = React.useState<UrlParamType>({
    campaignId: NO_CURRENT_ENTITY,
    clientId: NO_CURRENT_ENTITY,
    proposalId: NO_CURRENT_ENTITY,
    productId: NO_CURRENT_ENTITY,
    committedProposalId: NO_CURRENT_ENTITY,
  });

  React.useEffect(() => {
    const {
      campaignId,
      clientId,
      proposalId,
      productId,
      committedProposalId,
    } = params;

    setParsedParams({
      campaignId: campaignId ? Number.parseInt(campaignId) : NO_CURRENT_ENTITY,
      clientId: clientId ? Number.parseInt(clientId) : NO_CURRENT_ENTITY,
      proposalId: proposalId ? Number.parseInt(proposalId) : NO_CURRENT_ENTITY,
      productId: productId ? Number.parseInt(productId) : NO_CURRENT_ENTITY,
      committedProposalId: committedProposalId
        ? Number.parseInt(committedProposalId)
        : NO_CURRENT_ENTITY,
    });
  }, [params]);

  React.useEffect(() => {
    dispatch(setCurrentCampaign(parsedParams.campaignId));
  }, [parsedParams?.campaignId]);

  React.useEffect(() => {
    dispatch(setCurrentClient(parsedParams.clientId));
  }, [parsedParams?.clientId]);

  React.useEffect(() => {
    dispatch(setCurrentProposal(parsedParams.proposalId));
  }, [parsedParams?.proposalId]);

  React.useEffect(() => {
    dispatch(setCurrentCommittedProposal(parsedParams.committedProposalId));
  }, [parsedParams?.committedProposalId]);

  /*   React.useEffect(() => {
    dispatch(setCurrentProduct(parsedParams.productId));
  }, [parsedParams?.productId]); */

  return null;
};
